import React, { Component } from 'react'
import firebase from 'firebase/app'
import logo from './../../assets/images/logo.png'
import { Redirect } from "react-router-dom"

import 'firebase/auth'
import './login.css'

class Login extends Component {
  constructor () {
    super ()
    this.state = {
      email: '',
      password: '',
      redirect: false
    }
    this.startSession = this.startSession.bind(this)
    this.bindForm = this.bindForm.bind(this)
  }

  startSession () {    
    firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
    .then(() => {
      localStorage.setItem('logged', true)   
      this.setState({ redirect: true })      
    })
    .catch(function(error) {
      var errorMessage = error.message
      alert(errorMessage)
    })
  }

  renderPanel = () => {
    if(this.state.redirect === true) {
      return <Redirect to='/panel' />
    }
  }

  bindForm (e) {
    this.setState({ [e.target.name] : e.target.value })
  }

  render () {     
    return (      
      <div className="container">
        {this.renderPanel()}
        <div className="login-container">
        <img src={logo} className="logo" alt="Logo IFH Instructores" />
          <p><input type="email" name="email" value={this.state.email} onChange={this.bindForm} placeholder="Correo electrónico" className="form-control"/></p>
          <p><input type="password" name="password" value={this.state.password} onChange={this.bindForm} placeholder="Contraseña" className="form-control"/></p>
          <p><input type="button" className="btn btn-success btn-block" value="Iniciar sesión" onClick={this.startSession} /></p>
        </div>         
      </div>
    )
  }
}

export default Login